<template lang="html">

  <div v-if="group === qdata.form.group && formdata[q_slug]" class="col-12 col-sm-6 text-center response">
    <div class="question-wrap">
      <h5 class="question">{{ qdata.q }}</h5>
    </div>

    <div v-for="ans in getAnsArray" class="ans-wrap">
      <h6 class="ans">{{ getAns(ans) }}</h6>

      <p class="advice">{{ getAdvice(ans) }}</p>
    </div>
  </div>

  <div v-else-if="qdata.id !== 0 && rdata.report[q_slug]" class="col-12 col-sm-6 text-center response">
    <div class="question-wrap">
      <h5 class="question">{{ qdata.q }}</h5>
    </div>

    <div class="ans-wrap">
      <h6 class="ans">{{ qdata.skipped }}</h6>

      <p class="advice">{{ rdata.report[q_slug].default }}</p>
    </div>
  </div>

</template>

<script>
export default {
  props: [ 'qdata', 'group' ],
  data() {
    return {
      rdata: this.$store.state.reporting[this.group],
      formdata: this.$store.state.formData,
      q_slug: this.qdata.form.prop,
      docDefinition: this.$store.state.docDefinition,
    }
  },
  methods: {
    getAdvice(ans) {
      let adv = this.rdata.report[ans];
      let response = false;
      let resp = '';

      if(adv === undefined){
        resp = response;
      } else {
        response = adv.all;
        resp = (typeof response === "string") ? response : this.isB2BorB2C(response,this.formdata["Company_Type"].value);
      }
      return resp;
    },
    isB2BorB2C(response,type){
      let b2c = (response.b2c === undefined) ? '' : response.b2c;
      let b2b = (response.b2b === undefined) ? '' : response.b2b;
      return type === 'b2c_company' ? b2c : b2b;
    },
    getAns(slug) {
      const opts = this.qdata.form.options;
      let pretty = '';

      Array.from(opts, (opt) => {
        if ( opt.value === slug ) {
          pretty = opt.label;
          return;
        }
      });

      return pretty;
    }
  },
  computed: {
    getAnsArray() {
      let ansArray = [];
      const q = this.q_slug;
      const ans = this.formdata[q].value;
      const opts = this.qdata.form.options;

      if ( ans.constructor === Array ) {
        Array.from(ans, (val) => {
          ansArray.push(val);
        });
      }
      else if ( ans.constructor === String ) {
        ansArray.push(ans);
      }

      return ansArray;
    }    
  },
  created() {
    if ( this.group === this.qdata.form.group && this.formdata[this.q_slug] ) {
      const question = {
        text: this.qdata.q.toUpperCase(),
        headlineLevel: 2,
        style: 'question'
      }

      this.docDefinition.content.push( question );

      Array.from(this.getAnsArray, (ans) => {
        const answer = {
          text: this.getAns(ans),
          headlineLevel: 3,
          style: 'answer'
        }
  
        const response = {
          text: this.getAdvice(ans),
          style: 'response'
        }

        this.docDefinition.content.push( answer, response );
      })
    }
    else if ( this.qdata.id !== 0 && this.rdata.report[this.q_slug] ) {
      const question = {
        text: this.qdata.q.toUpperCase(),
        headlineLevel: 2,
        style: 'question'
      }

      const answer = {
        text: this.qdata.skipped,
        headlineLevel: 3,
        style: 'answer'
      }

      const response = {
        text: this.rdata.report[this.q_slug].default,
        style: 'response'
      }

      this.docDefinition.content.push( question, answer, response );
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vars";
@import "../../assets/scss/mixins";

.response {

  &:not(:last-child) {
    margin-bottom: gu(2);
  }
}

.question-wrap {
  margin-bottom: gu(1);
}

.question {
  font-size: rem-calc(25);
  font-weight: $fwBold;
  text-transform: uppercase;
  line-height: 1;
  padding-left: gu(1);
  padding-right: gu(1);
  margin-bottom: gu(0.4);
  color: $colTeal;
}

.ans {
  font-size: rem-calc(22);
  font-weight: $fwBold;
  line-height: 1;
  color: $colDOrange;
  margin-bottom: gu(0.8);
}

.advice {
  text-align: left;
  font-size: rem-calc(18);
  font-weight: $fwReg;
  color: $colDGray;
}
</style>
